module.exports = __webpack_public_path__ + "media/images/category_icons/countries-86817b515935aa2f25963cf68b8e8403.svg";